import styled, { css } from 'styled-components';

export const ButtonGroup = styled.div`
  position: relative;
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: flex-start;
`;

export const CommonState = css`
  &:focus {
    outline: none;
    svg {
      fill: ${(props) => props.theme.colors.gray600};
      stroke: ${(props) => props.theme.colors.gray600};
      margin: 5%;
    }

    span {
      color: ${(props) => props.theme.colors.gray600};
    }
  }
`;

const Button = styled.button`
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  box-sizing: border-box;
  font-size: 1rem;
  word-break: normal;
  ${CommonState}
`;

export const ToolbarButton = styled(Button)`
  background-color: transparent;

  &.common {
    span {
      color: ${(props) => props.theme.colors.gray600};
    }
    svg {
      fill: ${(props) => props.theme.colors.gray600};
      stroke: ${(props) => props.theme.colors.gray600};
    }
  }

  .toolArrow {
    font-size: 0.9rem;
  }
  
  span {
    color: ${(props) => props.theme.colors.gray800};
    width: auto;
    white-space: nowrap;
    padding: 0 0;
    transition: color 0.3s ease, background 0.3s ease, padding 0.3s ease;
  }
  svg {
    fill: ${(props) => props.theme.colors.gray800};
    stroke: ${(props) => props.theme.colors.gray800};
    margin: 5%;
  }

  &.selected {
    svg {
      fill: ${(props) => props.theme.colors.smokeWhite};
      stroke: ${(props) => props.theme.colors.smokeWhite};
      margin: 5%;
    }
    span {
      color: ${(props) => props.theme.colors.smokeWhite};
      padding: 0 0;
      transition: color 0.3s ease, background 0.3s ease, padding 0.3s ease;
    }
  }
  
  &.enabled {
    svg {
      fill: ${(props) => props.theme.colors.gray600};
      stroke: ${(props) => props.theme.colors.gray600};
      margin: 5%;
    }
    span {
      color: ${(props) => props.theme.colors.gray600};
      background: linear-gradient(to right, transparent, #000A 5%, #000A 95%, transparent);
      padding: 0 8px;
      z-index: 2;
      transition: color 0.3s ease, background 0.3s ease, padding 0.3s ease;
    }
  }

    @media (hover: hover) {
      :hover {
        svg {
          fill: ${(props) => props.theme.colors.smokeWhite};
          stroke: ${(props) => props.theme.colors.smokeWhite};
          margin: 5%;
        }
        color: ${(props) => props.theme.colors.smokeWhite};
        transition: color 0.3s ease;
        span {
          color: ${(props) => props.theme.colors.smokeWhite};
          background: linear-gradient(to right, transparent, #000A 5%, #000A 95%, transparent);
          padding: 0 8px;
          z-index: 4;
          transition: color 0.3s ease, padding 0.3s ease;
        }
      }
    }

    &:focus {
      outline: none;
      svg {
        fill: ${(props) => props.theme.colors.smokeWhite};
        stroke: ${(props) => props.theme.colors.smokeWhite};
        margin: 5%;
      }

      span {
        color: ${(props) => props.theme.colors.smokeWhite};
      }
  
    @media (max-height: ${(props) => props.theme.sizes.smaller}) {
      span {
        display: none;
      }
    }
`;

export const ButtonWithNoState = styled(Button)`
  background-color: transparent;
  span {
    color: ${(props) => props.theme.colors.gray600};
    width: auto;
  }
  svg {
    fill: ${(props) => props.theme.colors.gray600};
    stroke: ${(props) => props.theme.colors.gray600};
    margin: 5%;
  }

  @media (hover: hover) {
    :hover {
      svg {
        fill: ${(props) => props.theme.colors.smokeWhite};
        stroke: ${(props) => props.theme.colors.smokeWhite};
        margin: 5%;
      }
      color: ${(props) => props.theme.colors.smokeWhite};
      span {
        color: ${(props) => props.theme.colors.smokeWhite};
      }
    }
  }

  @media (max-height: ${(props) => props.theme.sizes.smaller}) {
    span {
      display: none;
    }
  }
`;
